import type { ReactNode } from 'react';
import { PureComponent } from 'react';

import { Header, Progress, Spacer, Text } from '@procurify/ui'
import { FormattedMessage } from 'react-intl'

import { FormattedEnhancedMessage } from '@webapp/core/hoc/FormattedEnhancedMessage'
import messages from '../../messages'
import { ImporterContentStyled as Content } from '../../styles/ImporterContentStyled'

export interface IImporterLoadingStageProps {
  title?: ReactNode
  message?: ReactNode
}

export class ImporterLoadingStage extends PureComponent<IImporterLoadingStageProps> {
  static readonly defaultProps = {
    title: <FormattedMessage {...messages.uploadingStepTitle} />,
    message: (
      <FormattedEnhancedMessage {...messages.processingStepDescription} />
    ),
  }

  render() {
    const { title, message } = this.props

    return (
      <Content width={480}>
        <Header as='h3' gutter>
          {title}
        </Header>

        <Text>{message}</Text>

        <Spacer />

        <Progress />
      </Content>
    )
  }
}
